import React from 'react';
import whatsapp from './whatsapp.png';
import styled from "styled-components";

interface Props {

}

export const WhatsAppIcon: React.FC<Props> = (props: Props) => {
    const { } = props;

    return (
        <Image src={whatsapp} alt="WhatsApp Icon" />
    );
}

const Image = styled.img`
    height: 1em;
`;